var VideoDataSet = {
  'APPROPRIATE CULTURE SEASON 2': {
      "title": "APPROPRIATE CULTURE SEASON 2",
      'description': 'Appropriate Culture is a sitcom that follows a quirky ensemble artist family as they navigate a series of hilarious misadventures. Packed with humor and heart, each episode highlights their unique dynamics and the unexpected situations that bring them closer together.',
      'genre': 'Comedy',
      'artist': 'Julian Stephen, Justin Gerard, Tim Simonson, Cleverly Chloe, Julius Stukes Jr., Alexa Leighton',
      'playlist': true,
      'episodes': [
          {
              'playlist-id': 1,
              'name': 'EPISODE 1',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/APPROPRIATE+CULTURE+S2/Appropriate_Culture___S2_EP1___EX-TRAVAGANZA_copy_r1fkhi.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/AC2+-+EPS+1-6/Appropriate_Culture___S2_EP1___EX-TRAVAGANZA_copy_lfo4su.jpg'
          },
          {
              'playlist-id': 2,
              'name': 'EPISODE 2',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/APPROPRIATE+CULTURE+S2/Appropriate_Culture___S2_EP2___CODES_SWITCHED_copy_bt1bvo.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/AC2+-+EPS+1-6/Appropriate_Culture___S2_EP2___CODES_SWITCHED_copy_fbwtrp.jpg'
          },
          {
              'playlist-id': 3,
              'name': 'EPISODE 3',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/APPROPRIATE+CULTURE+S2/Appropriate_Culture___S2_EP3___HATFISHED_copy_axcu6z.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/AC2+-+EPS+1-6/Appropriate_Culture___S2_EP3___HATFISHED_copy_ujiwra.jpg'
          },
          {
              'playlist-id': 4,
              'name': 'EPISODE 4',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/APPROPRIATE+CULTURE+S2/Appropriate_Culture___S2_EP4___WRITER_S_BLOCKED_copy_kqrjcs.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/AC2+-+EPS+1-6/Appropriate_Culture___S2_EP4___WRITER_S_BLOCKED_copy_ahcy2l.jpg'
          },
          {
              'playlist-id': 5,
              'name': 'EPISODE 5',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/APPROPRIATE+CULTURE+S2/Appropriate_Culture___S2_EP5___CANCELLED_copy_ihv6lq.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/AC2+-+EPS+1-6/Appropriate_Culture___S2_EP5___CANCELLED_copy_a4klgf.jpg'
          },
          {
              'playlist-id': 6,
              'name': 'EPISODE 6',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/APPROPRIATE+CULTURE+S2/Appropriate_Culture___S2_EP_6___GAME_NIGHT_copy_q8uygu.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/AC2+-+EPS+1-6/Appropriate_Culture___S2_EP_6___GAME_NIGHT_copy_w7amds.jpg'
          },
      ]
  },
  'ALIEN N KICK': {
      "title": "ALIEN N KICK",
      'playlist': true,
      'description' : 'The 13-episode sitcom prequel to Appropriate Culture follows the quirky family as they navigate a series of hilarious misadventures. Packed with humor and heart, each episode showcases their unique dynamics and the unexpected situations that bring them closer together.',
      'genre' : 'Comedy',
      'artist' : 'Julian Stephen, Justin Gerard, Tim Simonson',
      'episodes': [
          {
              'playlist-id': 1,
              'name': 'Bullseye',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/ALIENNKICK/AlienNkick_-_Bullseye_copy_xkmhxh.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/ALIEN+N+KICK/AlienNkick_-_Bullseye_copy_hjrj7l.jpg'
          },
          {
              'playlist-id': 2,
              'name': 'Payoffs',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/ALIENNKICK/AlienNkick_-_Payoffs_copy_t1xjjc.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/ALIEN+N+KICK/AlienNkick_-_Payoffs_copy_nsay3p.jpg'
          },
          {
              'playlist-id': 3,
              'name': 'Flirty Dancing',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/ALIENNKICK/AlienNkick_-_Flirty_Dancing_copy_yk64vg.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/ALIEN+N+KICK/AlienNkick_-_Flirty_Dancing_copy_ag6ipa.jpg'
          },
          {
              'playlist-id': 4,
              'name': 'Teachers Threat',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/ALIENNKICK/AlienNkick_-_Teachers_Threat_copy_h7db3u.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/ALIEN+N+KICK/AlienNkick_-_Teachers_Threat_copy_do96tk.jpg'
          },
          {
              'playlist-id': 5,
              'name': 'Tripping Out',
              'link': "https://res.cloudinary.com/dts5uxlug/video/upload/v1675713291/WEBSITE%20ASSETS/ALIENNKICK/AlienNKick_-_Tripping_Out_copy_cpmd9s.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/ALIEN+N+KICK/AlienNKick_-_Tripping_Out_copy_jti3al.jpg'
          },
          {
              'playlist-id': 6,
              'name': 'Whooped Speechless',
              'link': "https://res.cloudinary.com/dts5uxlug/video/upload/v1675713096/WEBSITE%20ASSETS/ALIENNKICK/AlienNKick_-_Whooped_Speechless_copy_ojzqtp.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/ALIEN+N+KICK/AlienNKick_-_Whooped_Speechless_copy_yqn8uj.jpg'
          },
          {
              'playlist-id': 7,
              'name': 'Lil Young',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/ALIENNKICK/AlienNKick_-_Lil_Young_copy_vxcyg8.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/ALIEN+N+KICK/AlienNKick_-_Lil_Young_copy_tict7a.jpg'
          },
          {
              'playlist-id': 8,
              'name': 'Quality Time',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/ALIENNKICK/AlienNKick_-_Quality_Time_copy_tz1xum.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/ALIEN+N+KICK/AlienNKick_-_Quality_Time_copy_fioyus.jpg'
          },
          {
              'playlist-id': 9,
              'name': 'Lost in Transportation',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/ALIENNKICK/AlienNKick_-_Lost_in_Transportation_copy_jlmrqz.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/ALIEN+N+KICK/AlienNKick_-_Lost_in_Transportation_copy_rh3vq7.jpg'
          },
          {
              'playlist-id': 10,
              'name': 'RoadTest Pt 1',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/ALIENNKICK/AlienNkick_-_RoadTest_Pt_1_copy_cykpgk.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/ALIEN+N+KICK/AlienNkick_-_RoadTest_Pt_1_copy_kkaclg.jpg'
          },
          {
              'playlist-id': 11,
              'name': 'Roadtest Pt 2',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/ALIENNKICK/AlienNKick_-_Roadtest_Pt_2_copy_h86hd8.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/ALIEN+N+KICK/AlienNKick_-_Roadtest_Pt_2_copy_mlz6ip.jpg'
          },
          {
              'playlist-id': 12,
              'name': 'This Trip Sucks',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/ALIENNKICK/AlienNKick_-_This_Trip_Sucks_copy_tz9vpx.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/ALIEN+N+KICK/AlienNKick_-_This_Trip_Sucks_copy_z5httl.jpg'
          },
          {
              'playlist-id': 13,
              'name': 'Did I Do',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/ALIENNKICK/AlienNKick_-_Did_I_Do_That_copy_cs3kxl.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/ALIEN+N+KICK/AlienNKick_-_Did_I_Do_That__copy_diag4o.jpg'
          },
      ]
  },
  'APPROPRIATE CULTURE SEASON ONE': {
      "title": "APPROPRIATE CULTURE SEASON ONE",
      'playlist': true,
      'description': 'Appropriate Culture is a sitcom that follows a quirky ensemble artist family as they navigate a series of hilarious misadventures. Packed with humor and heart, each episode highlights their unique dynamics and the unexpected situations that bring them closer together.',
      'genre': 'Comedy',
      'artist': `Julian Stephen, Justin Gerard, Tim Simonson, Cleverly Chloe, Julius Stukes Jr., Alexa Leighton`,
      'episodes': [
          {
              'playlist-id': 1,
              'name': 'EPISODE 1',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/APPROPRIATE+CULTURE+S1/Appropriate_Culture___S1_EP_1___Health_Nuts_copy_fkdvoz.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/AC1+-+EPISODES+1-5/Appropriate_Culture___S1_EP_1___Health_Nuts_copy_x2mr4g.jpg'
          },
          {
              'playlist-id': 2,
              'name': 'EPISODE 2',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/APPROPRIATE+CULTURE+S1/Appropriate_Culture___S1_EP_2___2_K_copy.O_hucvgs.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/AC1+-+EPISODES+1-5/Appropriate_Culture___S1_EP_2___2_K_copy_h2gpkm.jpg'
          },
          {
              'playlist-id': 3,
              'name': 'EPISODE 3',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/APPROPRIATE+CULTURE+S1/Appropriate_Culture___S1_EP_3___Netflix_Kill_copy_kcyd6n.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/AC1+-+EPISODES+1-5/Appropriate_Culture___S1_EP_3___Netflix_Kill_copy_fvpwo8.jpg'
          },
          {
              'playlist-id': 4,
              'name': 'EPISODE 4',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/APPROPRIATE+CULTURE+S1/Appropriate_Culture___S1_EP_4___Blind_Date_copy_vxyskm.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/AC1+-+EPISODES+1-5/Appropriate_Culture___S1_EP_4___Blind_Date_copy_muztce.jpg'
          },
          {
              'playlist-id': 5,
              'name': 'EPISODE 5',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/APPROPRIATE+CULTURE+S1/Appropriate_Culture___S1_EP_5___HR_Blocked_copy_izziov.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/AC1+-+EPISODES+1-5/Appropriate_Culture___S1_EP_5___HR_Blocked_copy_gosqva.jpg'
          },
      ]
  },
  'BUGGING GILBERT': {
      "title": "BUGGING GILBERT",
      'playlist': false,
      'description': 'Bugging Gilbert is a comedic animated series from creator Justin Gerard that follows young Gilbert as he navigates life while being hilariously harassed by a mischievous roach that only he can see. Each episode features Gilbert’s wild attempts to maintain his sanity, leading to chaos and laughter as he tries to outsmart his tiny, troublesome foe!',
      'genre': 'Animation, Comedy',
      'artist': 'Justin Gerard, Timothy Simonson',
      'episodes': [
          {
              'playlist-id': 1,
              'name': 'EPISODE 1',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/BUGGING+GILBERT/Y2Mate.is_-_Original_animated_series_Bugging_Gilbert_Film_Bug-AVbdS42XGAo-1080p-1656390659606_wg7q2k.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/Bugging_Gilbert_ktdmei.jpg'
          },
      ]
  },
  'DETECTIVE BLK': {
      "title": "DETECTIVE BLK",
      'playlist': false,
      'description' : 'In this thrilling 70s action comedy, Detective Blk takes on a ruthless crime syndicate that’s wreaking havoc in the city. With a blend of humor and high-stakes action, he navigates a world of corruption and chaos to bring the villains to justice.',
      'genre' : 'Action Comedy',
      'artist' : 'Julius Stukes Jr., Taurian Blakeney, June Brown, Preach Gold, Justin Gerard, Alexa Leighton, Brandon Sngdnc Mellette',
      'episodes': [
          {
              'playlist-id': 1,
              'name': 'EPISODE 1',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/DETECTIVE+BLK/DETECTIVE_BLK_SEASON_1_onwk9h.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/DETECTIVE+BLK+SZN/DETECTIVE_BLK_SEASON_fwoeov.jpg'
          },
      ]
  },
  'Playa PLaya Sophisticated Thoughts': {
      "title": "Music Visual Collection",
      'playlist': true,
      'episodes': [
          {
              'playlist-id': 1,
              'name': 'Playa Playa',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/MUSIC+VISUAL+COLLECTION/julian_stephen_-_playa_playa_copy_evkwb0.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/MUSIC+VISUAL+COLLECTION/PLAYA_PLAYA_xxoqpf.jpg'
          },
          {
              'playlist-id': 2,
              'name': 'Creepin',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/MUSIC+VISUAL+COLLECTION/Julian_Stephen-_69_Creepin_copy_ahpwcc.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/MUSIC+VISUAL+COLLECTION/CREEPIN_zzwmzb.jpg'
          },
          {
              'playlist-id': 3,
              'name': "When I 'm lonely",
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/MUSIC+VISUAL+COLLECTION/julian_stephen_-_when_I_m_Lonely_copy_wed1od.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/MUSIC+VISUAL+COLLECTION/WHEN_IM_LONELY_xhedsd.jpg'
          },
          {
              'playlist-id': 4,
              'name': 'Streaming',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/MUSIC+VISUAL+COLLECTION/julian_stephen_-_streaming_copy_n52su4.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/MUSIC+VISUAL+COLLECTION/STREAMING_tskyv1.jpg'
          },
          {
              'playlist-id': 5,
              'name': 'Sophisticated thoughts',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/MUSIC+VISUAL+COLLECTION/julian_stephen_-_sophisticated_thoughts_copy_jue6kn.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/MUSIC+VISUAL+COLLECTION/SOPHISTICATED_THOUGHTS_rntpit.jpg'
          },
      ]
  },
  'YOUR FRIEND JIGGY': {
      "title": "YOUR FRIEND JIGGY",
      'playlist': true,
      'description' : 'In this engaging educational children’s show, follow Jiggy the Puppet as he explores a variety of subjects in a fun and interactive way. Created by Jarrett Jiggy Manigault and Brandon Sngdnc Mellette, Jiggy makes learning exciting and accessible for young audiences!',
      'genre' : 'Educational, Youth',
      'artist' : '',
      'episodes': [
          {
              'playlist-id': 1,
              'name': 'Counting',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/YOUR+FRIEND+JIGGY/Counting_copy_walnks.mp4",
              'img': ''
          },
          {
              'playlist-id': 2,
              'name': 'Shapes',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/YOUR+FRIEND+JIGGY/shApes_SQUARE_copy_low932.mp4",
              'img': ''
          },
          {
              'playlist-id': 3,
              'name': 'Months',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/YOUR+FRIEND+JIGGY/MONTHSS_1_copy_lwan5x.mp4",
              'img': ''
          },
          {
              'playlist-id': 4,
              'name': 'Days of the Week',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/YOUR+FRIEND+JIGGY/Days_of_the_week_Square_copy_e7hnst.mp4",
              'img': ''
          },
      ]
  },
  'APPROPRIATE CHRISTMAS SPECIAL': {
      "title": "APPROPRIATE CHRISTMAS SPECIAL",
      'playlist': false,
      'description' : 'Appropriate Culture: Holiday Special is a heartwarming sitcom that follows a quirky ensemble artist family as they dive into a series of hilarious holiday misadventures. Packed with humor and warmth, this special showcases their unique dynamics and the unexpected situations that bring them closer together during the festive season. Join them for laughter, love, and the true spirit of family as they navigate the ups and downs of holiday celebrations!',
      'genre' : 'Comedy',
      'artist' : 'Julian Stephen, Justin Gerard, Tim Simonson, Cleverly Chloe, Julius Stukes Jr., Alexa Leighton',
      'episodes': [
          {
              'playlist-id': 1,
              'name': 'EPISODE 1',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/APPROPRIATE++HOLIDAY+SPECIAL/Appropriate_Culture_-_Holiday_Special_copy_okbu4g.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/APPROPRIATE+HOLIDAY+SPECIAL/Appropriate_Culture_-_Holiday_Special_copy_f4273t.jpg'
          },
      ]
  },
  'APPROPRIATE CULTURE SEASON 1.5': {
      "title": "APPROPRIATE CULTURE SEASON 1.5",
      'playlist': true,
      'description': 'Appropriate Culture is a sitcom that follows a quirky ensemble artist family as they navigate a series of hilarious misadventures. Packed with humor and heart, each episode highlights their unique dynamics and the unexpected situations that bring them closer together.',
      'genre': 'Comedy',
      'artist': `Julian Stephen, Justin Gerard, Tim Simonson, Cleverly Chloe, Julius Stukes Jr., Alexa Leighton`,
      'episodes': [
          {
              'playlist-id': 1,
              'name': 'The Ex Man & The Next Man ',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/APPROPRIATE+CULTURE+S3/_W_THE_EX_MAN_AND_THE_NEXT_MAN_.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/AC3/THE_EX_MAN_AND_THE_NEXT_MAN_n7kpiv.png'
          },
          {
              'playlist-id': 2,
              'name': 'Learning to let it go',
              'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/APPROPRIATE+CULTURE+S3/LEARNING_TO_LET_IT_GO_.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/AC3/LEARNING_TO_LET_IT_GO_maajce.png'
          },
          {
              'playlist-id': 3,
              'name': 'Only Fans',
              'link': "https://res.cloudinary.com/dts5uxlug/video/upload/v1680876735/WEBSITE%20ASSETS/APPROPRIATE%20CULTURE%20S3/ONLY_FANS_.mp4",
              'img': 'https://justcreate-default-media.s3.eu-north-1.amazonaws.com/cover/AC3/ONLY_FANS_jg01yt.png'
          }
      ]
  },
   'CHRONICLES OF COFFY': {
          "title": "CHRONICLES OF COFFY",
          'playlist': false,
          'description': "In this prequel to Detective Black, we explore Officer Coffy’s origin story as he confronts the ruthless Train Wreck. Striving to forge his own path, Coffy faces challenges that will define his role as Detective Blk's trusted sidekick.",
          'genre': 'Comedy Action',
          'artist': `Justin Gerard, Enoch, Jeremy Arzon`,
          'episodes': [
              {
                  'playlist-id': 1,
                  'name': 'CHRONICLES OF COFFY',
                  'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/CHRONICLES+OF+COFFY/CHRONICLESOFCOFFY_1_hq7410.mov",
              }
          ]
      },
    'AUTONOMY : Attack of the Robots': {
          "title": "AUTONOMY : Attack of the Robots",
          'playlist': false,
          'description': "In this live-action Afro-futurism anthology saga, a daring Spaceteam fights for the last surviving humans on Earth in a post-tech world. As the looming enemy threatens their existence, they embark on an epic two-part adventure, blending culture, resilience, and innovation to protect their future.",
          'genre': 'Sci-Fi',
          'artist': `Justin Gerard, Tim Simonson, Vince Chang, Victoria Veedot Lewis, Jade Nikaylah, Imani Brammer, Julian Stephen, Jarrett Manigault`,
          'episodes': [
              {
                  'playlist-id': 1,
                  'name': 'AUTONOMY : Attack of the Robots',
                  'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/AUTONOMY/AUTONOMY_4_CREDIT_UPDATE_vl6g5o.mov",
              }
          ]
      },
    'MY EX BILLIONAIRE FIANCEE': {
          "title": "MY EX BILLIONAIRE FIANCEE",
          'playlist': false,
          'description': "In this hilarious comedy, Harry discovers his new girlfriend's ex is a billionaire tech mogul. As the billionaire sets outrageous traps to break them up, Harry must outsmart him and prove that love can overcome any obstacle!",
          'genre': 'Romance Comedy',
          'artist': `Justin Gerard, Imani Brammer, Tim Simonson, Ally Leftridge, Julian Stephen`,
          'episodes': [
              {
                  'playlist-id': 1,
                  'name': 'MY EX BILLIONAIRE FIANCEE',
                  'link': "https://justcreate-default-media.s3.eu-north-1.amazonaws.com/video/FULLER_MOVIE_fpwen5.mov",
              }
          ]
      },
}

export default VideoDataSet